import { render } from "./WIP.vue?vue&type=template&id=2fff295f&scoped=true&lang=html"
import script from "./WIP.vue?vue&type=script&lang=js"
export * from "./WIP.vue?vue&type=script&lang=js"

import "./WIP.vue?vue&type=style&index=0&id=2fff295f&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fff295f"]])

export default __exports__